<svg
  width="63"
  height="64"
  viewBox="0 0 63 64"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M26.9266 10.6004L4.76191 47.6025C4.30493 48.3939 4.06313 49.2912 4.06057 50.205C4.05801 51.1189 4.29478 52.0175 4.74733 52.8114C5.19987 53.6054 5.85241 54.267 6.64004 54.7304C7.42766 55.1939 8.32291 55.443 9.23671 55.4531H53.566C54.4798 55.443 55.3751 55.1939 56.1627 54.7304C56.9503 54.267 57.6028 53.6054 58.0554 52.8114C58.5079 52.0175 58.7447 51.1189 58.7422 50.205C58.7396 49.2912 58.4978 48.3939 58.0408 47.6025L35.8762 10.6004C35.4097 9.83133 34.7528 9.19547 33.969 8.75418C33.1852 8.31289 32.3009 8.08105 31.4014 8.08105C30.5019 8.08105 29.6175 8.31289 28.8337 8.75418C28.0499 9.19547 27.3931 9.83133 26.9266 10.6004Z"
    stroke="#E84741"
    stroke-width="5.23368"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M31.4019 24.0518V34.5191"
    stroke="#E84741"
    stroke-width="5.23368"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M31.4019 44.9863H31.428"
    stroke="#E84741"
    stroke-width="5.23368"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
